import { PageHeader } from "@/components/app/PageHeader/PageHeader";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailForm } from "./components/EmailForm";
import { PasswordForm } from "./components/PasswordForm";
import { DeleteAccountForm } from "./components/DeleteAccountForm";

const AccountPage: React.FC = () => {
	return (
		<div className="container max-w-screen-lg py-6">
			<PageHeader
				title="アカウント設定"
				description="アカウント情報の確認と編集ができます"
			/>
			<Tabs defaultValue="email" className="mt-6">
				<TabsList>
					<TabsTrigger value="email">メールアドレス</TabsTrigger>
					<TabsTrigger value="password">パスワード</TabsTrigger>
					<TabsTrigger value="delete">アカウント削除</TabsTrigger>
				</TabsList>
				<TabsContent value="email">
					<Card>
						<CardHeader>メールアドレスの変更</CardHeader>
						<CardContent>
							<EmailForm />
						</CardContent>
					</Card>
				</TabsContent>
				<TabsContent value="password">
					<Card>
						<CardHeader>パスワードの変更</CardHeader>
						<CardContent>
							<PasswordForm />
						</CardContent>
					</Card>
				</TabsContent>
				<TabsContent value="delete">
					<Card>
						<CardHeader>アカウントの削除</CardHeader>
						<CardContent>
							<DeleteAccountForm />
						</CardContent>
					</Card>
				</TabsContent>
			</Tabs>
		</div>
	);
};

export default AccountPage;
